import React from 'react'
import styled from 'styled-components'
import Modal from 'core-system/Modal'
import ClipperCardView from 'employee-platform/features/TransitPass/ClipperCardView'

const ScrollBody = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  padding: 1.5rem;
`

interface ClipperEnrollModalProps {
  open: boolean
  onClose: (_e?: React.MouseEvent<any>) => void
}

const ClipperEnrollModal: React.FC<ClipperEnrollModalProps> = ({ open, onClose }) => (
  <Modal open={open} onClose={onClose}>
    <ScrollBody>
      <ClipperCardView />
    </ScrollBody>
  </Modal>
)

export default ClipperEnrollModal
